import { render } from "./MenuManagement.vue?vue&type=template&id=65f0e642&scoped=true"
import script from "./MenuManagement.vue?vue&type=script&lang=js"
export * from "./MenuManagement.vue?vue&type=script&lang=js"

import "./MenuManagement.vue?vue&type=style&index=0&id=65f0e642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f0e642"]])

export default __exports__